import { apiGet } from "../../utils"

export function getCatelogListAPI(data) {
    // const { sort = '' } = data || {}
    return apiGet(`/api/getCatelogListWeb`, data)
}

export function getCatelogByIdAPI(id) {
    return apiGet(`/api/getCatelogById?release_id=${id}`)
}

export function getMusicLinksAPI(audio_id) {
    return apiGet(`/api/getMusicLinks`, { audio_id })
}

export function fetchMusicLinksAPI(audio_id) {
    return apiGet(`/api/fetchMusicLinks`, { audio_id })
}